import ChipReportTypeStatus from '@/components/chip/ChipReportTypeStatus';
import type { StatusChipProps } from '@/components/chip/ChipTicketStatus';
import { ReportTypeEnum } from '@/types/enums/report-type.enum';
import { t } from '@/utils/lang';

export const getReportTypeStatusData = (props: StatusChipProps) => {
    return ChipReportTypeStatus(props);
};

export const getReportTypeOptionsFilter = (isFilter?: boolean) => {
    const enumValues = ReportTypeEnum;

    const options: any[] = [];

    Object.keys(enumValues).forEach(key => {
        const data = getReportTypeStatusData({
            status: enumValues[key],
            showChip: false,
        });

        options.push({
            id: enumValues[key],
            value: !isFilter ? enumValues[key] : key.toUpperCase(),
            title: data.label,
            label: t(data.label),
        });
    });

    return options;
};
